import { useMarketAccount } from '@/contexts/useMarketAccount';
import { useAuth } from '@/contexts/AuthContext';

export default function MarketAccountPicker() {
  const { user } = useAuth();
  const { accounts, selectedId, select, loading, error, refresh } = useMarketAccount();
  if (!user) return <p className="text-xs text-text-secondary">登录并绑定账号后查看对应行情</p>;
  if (error) return <button className="text-xs text-brand-peri" onClick={refresh}>{error}，点击重试</button>;
  return <label className="flex items-center gap-2 text-xs text-text-secondary">
    <span>行情账号</span>
    <select aria-label="行情账号" value={selectedId} disabled={loading || !accounts.length}
      onChange={event => select(event.target.value)} className="min-w-0 rounded-lg border border-gray-200 bg-white px-2 py-1">
      <option value="">{loading ? '加载账号…' : accounts.length ? '请选择账号' : '请先绑定账号'}</option>
      {accounts.map(account => <option key={account.id} value={account.id}>
        {account.broker_name} · {account.account_no || account.mt4_login_masked || '交易账号'} · {account.server}
      </option>)}
    </select>
  </label>;
}
